import NewReportButton from '../components/atoms/new-report-button/NewReportButton';

export const ReportOverview = () => {
  return (
    <div>
      <p>Reports</p>
      <NewReportButton alignEnd={true} />
    </div>
  );
};
